/**
 * 多图工厂数据模型
 * @author jzs
 */

/**
 *  多图处理类型
 *  @crop crop类型
 *  @rect 矩形
 */
export enum ImageHandleType {
  cropai = "cropai",
  cropper = "cropper",
}

/**
 *  props传入图片类型-cropai类型
 *  @cropImage crop图地址
 *  @aiImage ai图地址
 */
export interface ImageListCropaiItem {
  cropImage: string;
  aiImage: string;
}

/**
 *  props传入图片类型-cropper类型
 *  @ratio 图片比例
 */
export interface ImageListCropperItem {
  width: number;
  height: number;
}

/**
 *  props传入图片类型
 *  @type 图片类型
 *  @default 默认图片
 */
export interface ImageListItem
  extends Partial<ImageListCropaiItem>,
    Partial<ImageListCropperItem> {
  type?: string;
  default?: string;
}

/**
 *  图片类型state
 */
export interface SourceListItem extends ImageListItem {
  source: string;
  handle?: string; // cropper or crop图
  ai?: string; // ai图
}

/**输出歌曲信息 */

export interface SpotifyTrack {
  album: string;
  albumThumbnail: string;
  name: string;
  artists: string;
  duration_ms: number;
  uri: string;
}

/**
 * 礼盒
 * @name 名称
 * @pic  图片URL
 * @price 价格
 * @id 物体id
 */
export interface Type {
  id: number;
  name: string;
  url: string;
  price: number;
}

/**
 * 第二件八折
 * @discount 折扣
 */
export interface IDoubleDesign {
  discount: any;
}

export interface ICustomOutput {
  images: any[];
  compose: string;
  spotifyTrack: SpotifyTrack;
  spotifyCodeStart?: string;
  giftBox?: Type;
}
